import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './ui/theme.css';
import { registerServiceWorker } from './lib/install.ts';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Offline shell and push. Failure here costs offline support, not
// function, so it is deliberately not awaited.
void registerServiceWorker();
